import { render, staticRenderFns } from "./iam-list-table.vue?vue&type=template&id=7b2873c6&"
import script from "./iam-list-table.vue?vue&type=script&lang=js&"
export * from "./iam-list-table.vue?vue&type=script&lang=js&"
import style0 from "./iam-list-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports